import styled from 'styled-components';

export const Container = styled.div`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -100px);
`;

export const Picture = styled.img`
    width: 100%;
    max-width: 130px;
`;
